import { put, delay, takeEvery, all, call, select } from "redux-saga/effects";
import _ from "lodash";
import moment from "moment-timezone";
import {
  setPageTopLoader,
  setPictreeDataReportTsuruTrend,
  setHomePictreeReportStats,
  setPictreeDataReportTrend,
} from "actions";
import { getJwtToken, getDataFromRDS, getDataFromSxi } from "api";
import { PICTREE, ENDPOINT } from "../../constants";
import * as H from "helper";
import seasonConfig from "../../utils/pictree/SeasonDataConfig";
import assetConfig from "../../utils/pictree/AssetConfig";

export const currentPage = (state) => state.page.currentPage;
export const dateRange = (state) => state.page.dateRangePicTree;
export const dateRangeNtt = (state) => state.page.dateRangePicTreeNtt;
export const dateRangeNttFt = (state) => state.page.dateRangePicTreeNttFt;
export const dateRangeHokuden = (state) => state.page.dateRangePicTreeHokuden;
export const selectedSeason = (state) => state.pictree.selectedSeason;
export const selectedSeasonNtt = (state) => state.pictreeNtt.selectedSeason;
export const selectedSeasonNttFt = (state) => state.pictreeNttFt.selectedSeason;
export const selectedSeasonHokuden = (state) => state.pictreeHokuden.selectedSeason;

const findSeason = (targetDate) => {
  // Convert the targetDate to a moment object for comparison
  const target = moment(targetDate, "YYYY-MM-DD");

  for (let config of seasonConfig.seasonConfig) {
    const startDate = moment(config.dateRange[0], "YYYY-MM-DD");
    const endDate = moment(config.dateRange[1], "YYYY-MM-DD");

    // Check if the target date falls within the date range
    if (target.isBetween(startDate, endDate, null, "[]")) {
      return typeof config.season !== "number"
        ? config.season
        : `Season${config.season}`;
    }
  }
  return null; // If no matching season is found
};

export function* getPictreeDataReportTsuruTrend(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRange); // ["2025-04-17", "2025-04-25"];
    const selectedSeasonData = yield select(selectedSeason);

    if (!rangeTarget || rangeTarget.length !== 2) {
      console.error("Invalid rangeTarget");
      yield put(setPageTopLoader(false));
      return;
    }

    if (!selectedSeasonData || selectedSeasonData.length === 0) {
      console.error("No seasons selected");
      yield put(setPageTopLoader(false));
      return;
    }
    const seasonIdList = selectedSeasonData.map(season => `${season.seasonId}`).join(", "); // "cm9jq577000034hpg5cngfzod"

    // query1: 台帳あり/報告あり 撮影本数
    // const sqlQueryCountReportTsuru = {
    //   query: `
    //     SELECT COUNT(DISTINCT pa.id) AS 'count-LedgerAndReport'
    //     FROM (
    //       SELECT rre.review_request_id, rre.occurred_datetime
    //       FROM review_request_event rre
    //       WHERE rre.type = 'APPLIED'
    //         AND rre.occurred_datetime BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 14:59:59'
    //     ) AS filtered_rre
    //     INNER JOIN review_request rr ON rr.id = filtered_rre.review_request_id
    //     INNER JOIN power_asset pa ON pa.id = rr.power_asset_id
    //     INNER JOIN power_asset_event pae ON pae.power_asset_id = pa.id
    //     INNER JOIN asset_event_of_review_approved aeora ON aeora.id = pae.id
    //     WHERE aeora.review_approved_count = '1'
    //       AND pae.game_space_id = '${seasonIdList}'
    //       AND pa.sub_type = 'WITH_PLANTS'
    //       AND EXISTS (
    //         SELECT 1
    //         FROM report_event re
    //         WHERE re.occurred_datetime = filtered_rre.occurred_datetime
    //           AND re.type = 'REGISTERED'
    //       )
    //   `,
    //   database: "KpiDashboard",
    //   type: "list",
    // };

    // query1: 台帳あり電柱の撮影本数の全量
    const sqlQueryCountDaichoAriAll = {
      query: `
        SELECT
          DATE(CONVERT_TZ(rre.occurred_datetime, '+00:00', '+09:00')) AS day,
          COUNT(pa.id) as 'LedgerTotal'
        FROM asset_event_of_review_approved aeora
        INNER JOIN power_asset_event pae ON pae.id = aeora.id
        INNER JOIN power_asset pa ON pa.id = pae.power_asset_id
        INNER JOIN review_request rr ON rr.power_asset_id = pa.id
        INNER JOIN review_request_event rre ON rre.review_request_id = rr.id
        WHERE aeora.review_approved_count = '1'
        AND pae.game_space_id = '${seasonIdList}'
        AND pa.sub_type = 'WITH_PLANTS'
        AND rre.type = 'APPLIED'
        AND CONVERT_TZ(rre.occurred_datetime, 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
        GROUP BY day
        ORDER BY day;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    // query2: 台帳あり/報告なし 撮影本数
    const sqlQueryCountReportTsuruNoReport = {
      query: `
        SELECT
          DATE(CONVERT_TZ(rre.occurred_datetime, '+00:00', '+09:00')) AS day,
          COUNT(pa.id) as 'count-LedgerAndNoReport'
        FROM asset_event_of_review_approved aeora
        INNER JOIN power_asset_event pae ON pae.id = aeora.id
        INNER JOIN power_asset pa ON pa.id = pae.power_asset_id
        INNER JOIN review_request rr ON rr.power_asset_id = pa.id
        INNER JOIN review_request_event rre ON rre.review_request_id = rr.id
        WHERE aeora.review_approved_count = '1'
        AND CONVERT_TZ(rre.occurred_datetime, 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
        AND pae.game_space_id = '${seasonIdList}'
        AND pa.sub_type = 'WITH_PLANTS'
        AND rre.type = 'APPLIED'
        AND NOT EXISTS (
            SELECT 1
            FROM report_event re
            WHERE re.occurred_datetime = rre.occurred_datetime AND re.type = 'REGISTERED'
        )
        GROUP BY day
        ORDER BY day;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    // query3: 台帳なし/報告あり 撮影本数
    // const sqlQueryCountReportTsuruNoLedger = {
    //   query: `
    //     SELECT
    //       DATE(CONVERT_TZ(rre.occurred_datetime, '+00:00', '+09:00')) AS day,
    //       COUNT(DISTINCT pa.id) as 'count-NoLedgerAndReport'
    //     FROM asset_event_of_review_approved aeora
    //     INNER JOIN power_asset_event pae ON pae.id = aeora.id
    //     INNER JOIN power_asset pa ON pa.id = pae.power_asset_id
    //     INNER JOIN review_request rr ON rr.power_asset_id = pa.id
    //     INNER JOIN review_request_event rre ON rre.review_request_id = rr.id
    //     INNER JOIN report_event re ON re.occurred_datetime = rre.occurred_datetime
    //     AND rre.type = 'APPLIED' AND re.type = 'REGISTERED'
    //     WHERE aeora.review_approved_count = '1'
    //     AND CONVERT_TZ(rre.occurred_datetime, 'UTC', 'Asia/Tokyo')
    //     BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
    //     AND pae.game_space_id = '${seasonIdList}'
    //     AND pa.sub_type = 'NORMAL'
    //     GROUP BY day
    //     ORDER BY day;
    //   `,
    //   database: "KpiDashboard",
    //   type: "list",
    // };

    // query3:  台帳なし電柱の撮影本数の全量
    const sqlQueryCountDaichoNashiAll = {
      query: `
        SELECT
          DATE(CONVERT_TZ(rre.occurred_datetime, '+00:00', '+09:00')) AS day,
          COUNT(pa.id) as 'NoLedgerTotal'
        FROM asset_event_of_review_approved aeora
        INNER JOIN power_asset_event pae ON pae.id = aeora.id
        INNER JOIN power_asset pa ON pa.id = pae.power_asset_id
        INNER JOIN review_request rr ON rr.power_asset_id = pa.id
        INNER JOIN review_request_event rre ON rre.review_request_id = rr.id
        WHERE aeora.review_approved_count = '1'
        AND CONVERT_TZ(rre.occurred_datetime, 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
        AND pae.game_space_id = '${seasonIdList}'
        AND pa.sub_type = 'NORMAL'
        AND rre.type = 'APPLIED'
        GROUP BY day
        ORDER BY day;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    // query4: 台帳なし/報告なし 撮影本数
    const sqlQueryCountReportTsuruNoLedgerNoReport = {
      query: `
        SELECT
          DATE(CONVERT_TZ(rre.occurred_datetime, '+00:00', '+09:00')) AS day,
          COUNT(pa.id) as 'count-NoLedgerAndNoReport'
        FROM asset_event_of_review_approved aeora
        INNER JOIN power_asset_event pae ON pae.id = aeora.id
        INNER JOIN power_asset pa ON pa.id = pae.power_asset_id
        INNER JOIN review_request rr ON rr.power_asset_id = pa.id
        INNER JOIN review_request_event rre ON rre.review_request_id = rr.id
        WHERE aeora.review_approved_count = '1'
        AND CONVERT_TZ(rre.occurred_datetime, 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
        AND pae.game_space_id = '${seasonIdList}'
        AND pa.sub_type = 'NORMAL'
        AND rre.type = 'APPLIED'
        AND NOT EXISTS (
            SELECT 1
            FROM report_event re
            WHERE re.occurred_datetime = rre.occurred_datetime AND re.type = 'REGISTERED'
        )
        GROUP BY day
        ORDER BY day;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    const [tempLedgerAndReport, tempLedgerNoReport] = yield all([
      call(
        getDataFromSxi,
        sqlQueryCountDaichoAriAll, // 台帳あり電柱の撮影本数の全量
        ENDPOINT.GET_DATA_SXI_DENCHU,
        jwtToken
      ),
      call(
        getDataFromSxi,
        sqlQueryCountReportTsuruNoReport,
        ENDPOINT.GET_DATA_SXI_DENCHU,
        jwtToken
      ),
    ]);

    const [tempNoLedgerReport, tempNoLedgerNoReport] = yield all([
      call(getDataFromSxi,sqlQueryCountDaichoNashiAll,ENDPOINT.GET_DATA_SXI_DENCHU,jwtToken), //台帳なし電柱の撮影本数の全量
      call(getDataFromSxi, sqlQueryCountReportTsuruNoLedgerNoReport, ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken)
    ]);
    let xAxisDate = [],
      countLedgerAndReport = [],
      countLedgerNoReport = [],
      countNoLedgerReport = [],
      countNoLedgerNoReport = [];

    const daysArray = H.FormatDateHelper.getDaysListBetweenDays(rangeTarget[0], rangeTarget[1]);
    _.each(daysArray, function(data) {
        xAxisDate.push(data);
    });

    xAxisDate.forEach((date) => {
      const formatDate = (dt) => moment(dt).format("YYYY-MM-DD");

      // const matchLedgerAndReport = tempLedgerAndReport.find((item) =>
      //   formatDate(item.day) === date
      // );
      // const matchLedgerNoReport = tempLedgerNoReport.find((item) =>
      //   formatDate(item.day) === date
      // );
      // const matchNoLedgerReport = tempNoLedgerReport.find((item) =>
      //   formatDate(item.day) === date
      // );
      // const matchNoLedgerNoReport = tempNoLedgerNoReport.find((item) =>
      //   formatDate(item.day) === date
      // );

      // countLedgerAndReport.push(matchLedgerAndReport ? matchLedgerAndReport["count-LedgerAndReport"] : 0);
      // countLedgerNoReport.push(matchLedgerNoReport ? matchLedgerNoReport["count-LedgerAndNoReport"] : 0);
      // countNoLedgerReport.push(matchNoLedgerReport ? matchNoLedgerReport["count-NoLedgerAndReport"] : 0);
      // countNoLedgerNoReport.push(matchNoLedgerNoReport ? matchNoLedgerNoReport["count-NoLedgerAndNoReport"] : 0);

      // ── 台帳あり電柱の“全量”と“報告なし”を拾う
      const matchLedgerTotal     = tempLedgerAndReport.find(item => formatDate(item.day) === date);
      const matchLedgerNoReport  = tempLedgerNoReport  .find(item => formatDate(item.day) === date);

      // ── 台帳なし電柱の“全量”と“報告なし”を拾う
      const matchNoLedgerTotal    = tempNoLedgerReport      .find(item => formatDate(item.day) === date);
      const matchNoLedgerNoReport = tempNoLedgerNoReport    .find(item => formatDate(item.day) === date);

      // 値が取れなければ 0 とみなす
      const ledgerTotal     = matchLedgerTotal    ? matchLedgerTotal    .LedgerTotal     : 0;
      const ledgerNoReport  = matchLedgerNoReport ? matchLedgerNoReport["count-LedgerAndNoReport"] : 0;

      const noLedgerTotal    = matchNoLedgerTotal    ? matchNoLedgerTotal    .NoLedgerTotal   : 0;
      const noLedgerNoReport = matchNoLedgerNoReport ? matchNoLedgerNoReport["count-NoLedgerAndNoReport"] : 0;

      // 差し引いて“報告あり”を算出
      countLedgerAndReport.push(ledgerTotal    - ledgerNoReport);
      countLedgerNoReport.push(ledgerNoReport);

      countNoLedgerReport.push(noLedgerTotal  - noLedgerNoReport);
      countNoLedgerNoReport.push(noLedgerNoReport);
    });

    const reportTsuruTrendData = [{
      date: xAxisDate,
      countLedgerAndReport: countLedgerAndReport,
      countLedgerAndNoReport: countLedgerNoReport,
      countNoLedgerAndReport: countNoLedgerReport,
      countNoLedgerAndNoReport: countNoLedgerNoReport,
    }];
    console.log("LOG: reportTsuruTrendData", reportTsuruTrendData);
    yield put(setPictreeDataReportTsuruTrend(reportTsuruTrendData));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getHomePictreeReportStats(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const companyName = action.payload.toUpperCase();
    const rangeTarget = yield select(action.payload === "ntt"
      ? dateRangeNtt
      : action.payload === "ntt-ft"
        ? dateRangeNttFt
        : action.payload === "hepco"
          ? dateRangeHokuden
          : dateRange);
    const selectedSeasonData = yield select(action.payload === "ntt"
      ? selectedSeasonNtt
      : action.payload === "ntt-ft"
        ? selectedSeasonNttFt
        : action.payload === "hepco"
          ? selectedSeasonHokuden
          : selectedSeason);
    yield put(setHomePictreeReportStats({}));

    if (!rangeTarget || rangeTarget.length !== 2) {
      console.error("Invalid rangeTarget");
      yield put(setPageTopLoader(false));
      return;
    }

    if (!selectedSeasonData || selectedSeasonData.length === 0) {
      console.error("No seasons selected");
      yield put(setPageTopLoader(false));
      return;
    }
    let homeDataReportStats = {
      totalCount: "loading",
      totalPlayerCount: "loading",
      reportStats: [],
    };
    yield put(setHomePictreeReportStats(homeDataReportStats));

    const seasonIdList = selectedSeasonData.map(season => `'${season.seasonId}'`).join(", ");
    const sqlQueryGetCountTotalReport = {
      query: `
        SELECT
          COUNT(DISTINCT rere.player_id) AS player_count
        FROM report rr
        JOIN report_content_detail rcd ON rr.id = rcd.report_id
        JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
        JOIN review_request rere ON rere.power_asset_id = rr.power_asset_id
          AND rere.player_id = rr.player_id
          AND rere.status = 'APPROVED'
        JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
        WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
          AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') >= '${rangeTarget[0]} 00:00:00'
          AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') <= '${rangeTarget[1]} 23:59:59'
          AND ppa.game_space_id IN (${seasonIdList})
      `,
      database: "KpiDashboard",
      type: "list",
    };

    const sqlQueryGetCountByReport = {
      query: `
        SELECT
          COUNT(*) as total_count,
          tag_label,
          name
        FROM (
          SELECT DISTINCT rr.id, rcd.tag_label, rtdn.name
          FROM report rr
          JOIN report_content_detail rcd ON rr.id = rcd.report_id
          JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
          JOIN review_request rere ON rere.power_asset_id = rr.power_asset_id
            AND rere.player_id = rr.player_id
            AND rere.status = 'APPROVED'
          JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
          WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
            AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') >= '${rangeTarget[0]} 00:00:00'
            AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') <= '${rangeTarget[1]} 23:59:59'
            AND ppa.game_space_id IN (${seasonIdList})
        ) AS distinct_reports
        GROUP BY tag_label, name
        ORDER BY total_count DESC
      `,
      database: "KpiDashboard",
      type: "list",
    };

    const [tempReportTotal, tempReportStats] = yield all([
      call(getDataFromSxi,sqlQueryGetCountTotalReport,ENDPOINT.GET_DATA_SXI_DENCHU,jwtToken),
      call(getDataFromSxi,sqlQueryGetCountByReport,ENDPOINT.GET_DATA_SXI_DENCHU,jwtToken),
    ]);
    const { reportTagSortTepco } = assetConfig;
    const sortedReportStats = [...tempReportStats].sort((a, b) => {
      const indexA = reportTagSortTepco.indexOf(a.tag_label);
      const indexB = reportTagSortTepco.indexOf(b.tag_label);

      const safeIndexA = indexA === -1 ? 999 : indexA;
      const safeIndexB = indexB === -1 ? 999 : indexB;

      return safeIndexA - safeIndexB;
    });
    homeDataReportStats = {
      totalCount: tempReportStats.reduce((sum, stat) => sum + (stat.total_count || 0), 0),
      totalPlayerCount: tempReportTotal.length > 0 ? tempReportTotal[0].player_count : 0,
      reportStats: action.payload === "tepco" ? sortedReportStats : tempReportStats,
    };
    yield put(setHomePictreeReportStats(homeDataReportStats));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getHomePictreeReportTrend(action) {
  try {
    yield put(setPageTopLoader(true));
    yield put(setPictreeDataReportTrend([]));
    const jwtToken = yield call(getJwtToken);
    const companyName = action.payload.toUpperCase();
    const rangeTarget = yield select(action.payload === "ntt"
      ? dateRangeNtt
      : action.payload === "ntt-ft"
        ? dateRangeNttFt
        : action.payload === "hepco"
          ? dateRangeHokuden
          : dateRange);
    const selectedSeasonData = yield select(action.payload === "ntt"
      ? selectedSeasonNtt
      : action.payload === "ntt-ft"
        ? selectedSeasonNttFt
        : action.payload === "hepco"
          ? selectedSeasonHokuden
          : selectedSeason);
    console.log("LOG: selectedSeasonData", selectedSeasonData);
    if (!rangeTarget || rangeTarget.length !== 2) {
      console.error("Invalid rangeTarget");
      yield put(setPageTopLoader(false));
      return;
    }

    if (!selectedSeasonData || selectedSeasonData.length === 0) {
      console.error("No seasons selected");
      yield put(setPageTopLoader(false));
      return;
    }
    let pictreeReportTrend = {
      data: "loading",
    };
    yield put(setPictreeDataReportTrend(pictreeReportTrend));

    const seasonIdList = selectedSeasonData.map(season => `'${season.seasonId}'`).join(", ");
    const sqlQueryGetCountByReport = {
      query: `
        SELECT
          DATE_FORMAT(CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00'), '%Y-%m-%d') AS report_date,
          rcd.tag_label,
          rtdn.name,
          COUNT(DISTINCT rr.id) AS total_count
        FROM report rr
        JOIN report_content_detail rcd ON rr.id = rcd.report_id
        JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
        JOIN review_request rere ON rere.power_asset_id = rr.power_asset_id
          AND rere.player_id = rr.player_id
          AND rere.status = 'APPROVED'
        JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
        WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
          AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') >= '${rangeTarget[0]} 00:00:00'
          AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') <= '${rangeTarget[1]} 23:59:59'
          AND ppa.game_space_id IN (${seasonIdList})
        GROUP BY report_date, rcd.tag_label, rtdn.name
        ORDER BY report_date ASC, total_count DESC
      `,
      database: "KpiDashboard",
      type: "list",
    };

    const [tempReportTrend] = yield all([
      call(getDataFromSxi,sqlQueryGetCountByReport,ENDPOINT.GET_DATA_SXI_DENCHU,jwtToken),
    ]);

    const dailyTrendMap = {};

    for (const item of tempReportTrend) {
      const date = item.report_date;
      if (!dailyTrendMap[date]) {
        dailyTrendMap[date] = {};
      }
      dailyTrendMap[date][item.tag_label] = item.total_count;
    }

    // 最終的な形式（ECharts準備用）：
    const formattedTrend = Object.entries(dailyTrendMap).map(([date, tagCounts]) => ({
      date,
      ...tagCounts, // 各tag_labelがkey
    }));

    pictreeReportTrend = {
      data: formattedTrend
    };
    yield put(setPictreeDataReportTrend(pictreeReportTrend));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}


export default function* watchPageSettings() {
  yield takeEvery(PICTREE.GET_REPORT_TSURU_TREND,getPictreeDataReportTsuruTrend);
  yield takeEvery(PICTREE.GET_HOME_REPORT_STATS, getHomePictreeReportStats);
  yield takeEvery(PICTREE.GET_REPORT_TREND, getHomePictreeReportTrend);
}
